// Rótulos de exibição para códigos internos (os códigos ficam sem acento; a tela, não).
export const RENEWAL_MODE_LABELS: Record<'manual' | 'automatica', string> = {
  manual: 'Manual',
  automatica: 'Automática',
};
